/**
 * Copyright (C) IRT GmbH 2020
 */

// define some fallbacks if KeyEvent interface is not defined (e.g. in standard desktop browsers)

module.exports = typeof KeyEvent === "undefined" ? {
    "VK_DOWN" : 40,
    "VK_UP" : 38,
    "VK_LEFT" : 37,
    "VK_RIGHT" : 39,
    "VK_ENTER" : 13,
    "VK_RED"   : 82,
    "VK_BLUE"  : 66,
    "VK_0"     : 48,
    "VK_2"     : 50,
    "VK_BACK"  : 8
} : KeyEvent;
